export const FETCH_ORGANISATION_SUB_FUNDS =
  'subFund/FETCH_ORGANISATION_SUB_FUNDS';
export const ADD_SUB_FUND = 'subFund/ADD_SUB_FUND';
export const UPDATE_SUB_FUND = 'subFund/UPDATE_SUB_FUND';
export const DELETE_SUB_FUND = 'subFund/DELETE_SUB_FUND';
export const SUB_FUND_COST = 'subFund/SUB_FUND_COST';
export const ADD_NEW_REPORTING_PERIOD = 'subFund/ADD_NEW_REPORTING_PERIOD';
export const FETCH_ORGANISATION_FILTER_SUB_FUNDS =
  'subFund/FETCH_ORGANISATION_FILTER_SUB_FUNDS';
export const DELETE_SUB_FUND_COST = 'subFund/DELETE_SUB_FUND_COST';
